var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#creditCard)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2 5H4.8C3.801 5 3.009 5.77875 3.009 6.75L3 17.25C3 18.2212 3.801 19 4.8 19H19.2C20.199 19 21 18.2212 21 17.25V6.75C21 5.77875 20.199 5 19.2 5ZM18.3 17.25H5.7C5.205 17.25 4.8 16.8562 4.8 16.375V12H19.2V16.375C19.2 16.8562 18.795 17.25 18.3 17.25ZM19.2 8.5H4.8V6.75H19.2V8.5Z",
    fill: "#295BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "creditCard"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.d5cebdf52db7eecf3d1f797d486f3718.svg";
export { ForwardRef as ReactComponent };